import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

export function ReviewDismissedText({info}: {info: IssueEventInfo}) {
  const {dismissalMessage} = info
  return (
    <>
      dismissed a review
      {dismissalMessage ? (
        <>
          <br />
          <span>{dismissalMessage}</span>
        </>
      ) : null}
    </>
  )
}
